/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DMPStatut { 
    statut: DMPStatut.StatutEnum;
    patientNom: string;
    patientNomNaissance?: string;
    patientPrenom: string;
    patientDateNaissance: string;
    patientGenreAdministratif: DMPStatut.PatientGenreAdministratifEnum;
    patientCivilite: DMPStatut.PatientCiviliteEnum;
    dateFermeture?: string;
    raisonFermeture?: string;
    statutMT: boolean;
}
export namespace DMPStatut {
    export type StatutEnum = 'OUVERT_AUTORISE' | 'OUVERT_NON_AUTORISE' | 'OUVERT_INTERDIT' | 'OUVERT_EXPIRE' | 'OUVERT_AUTORISATION_INCONNU' | 'CLOS' | 'INEXISTANT';
    export const StatutEnum = {
        OuvertAutorise: 'OUVERT_AUTORISE' as StatutEnum,
        OuvertNonAutorise: 'OUVERT_NON_AUTORISE' as StatutEnum,
        OuvertInterdit: 'OUVERT_INTERDIT' as StatutEnum,
        OuvertExpire: 'OUVERT_EXPIRE' as StatutEnum,
        OuvertAutorisationInconnu: 'OUVERT_AUTORISATION_INCONNU' as StatutEnum,
        Clos: 'CLOS' as StatutEnum,
        Inexistant: 'INEXISTANT' as StatutEnum
    };
    export type PatientGenreAdministratifEnum = 'M' | 'F' | 'U';
    export const PatientGenreAdministratifEnum = {
        M: 'M' as PatientGenreAdministratifEnum,
        F: 'F' as PatientGenreAdministratifEnum,
        U: 'U' as PatientGenreAdministratifEnum
    };
    export type PatientCiviliteEnum = 'Mr' | 'Mme' | 'Mlle';
    export const PatientCiviliteEnum = {
        Mr: 'Mr' as PatientCiviliteEnum,
        Mme: 'Mme' as PatientCiviliteEnum,
        Mlle: 'Mlle' as PatientCiviliteEnum
    };
}


